// Shared with the server via types/bcrSignatureSpacing.ts. Keep the runtime
// implementation inside the client so Next.js can bundle it with Turbopack.
// Persisted values identify geometry, not the user-facing names. Keep these
// stable so existing PDFs and DocuSign placements retain their saved spacing.
export const BCR_SIGNATURE_DENSITIES = [
  "extra-compact", "compact", "normal", "large",
] as const;

export type BcrSignatureDensity = typeof BCR_SIGNATURE_DENSITIES[number];

export const DEFAULT_NEW_BCR_SIGNATURE_DENSITY: BcrSignatureDensity = "compact";

export const BCR_SIGNATURE_SPACING_LABELS: Record<BcrSignatureDensity, string> = {
  "extra-compact": "Compact",
  compact: "Normal",
  normal: "Large",
  large: "Extra Large",
};

export const BCR_SIGNATURE_SPACING_OPTIONS = BCR_SIGNATURE_DENSITIES.map(value => ({
  value,
  label: BCR_SIGNATURE_SPACING_LABELS[value],
}));

// Missing values on legacy documents retain the previous "normal" geometry.
export function normalizeBcrSignatureDensity(
  value?: string | null,
  fallback: BcrSignatureDensity = "normal"
): BcrSignatureDensity {
  return BCR_SIGNATURE_DENSITIES.includes(value as BcrSignatureDensity)
    ? value as BcrSignatureDensity
    : fallback;
}

export function getDefaultBcrSignatureDensity(value?: string | null): BcrSignatureDensity {
  return normalizeBcrSignatureDensity(value, DEFAULT_NEW_BCR_SIGNATURE_DENSITY);
}

export function getBcrSignatureSpacingLabel(value?: string | null): string {
  return BCR_SIGNATURE_SPACING_LABELS[normalizeBcrSignatureDensity(value)];
}
